import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill-new';

const Text = React.memo(({ currentUser, value, instructions, inline }) => {
  let classNames = ['block-component-text'];

  if (inline) {
    classNames = classNames.concat(['my0', 'inline']);
  } else {
    classNames = classNames.concat(['mt0', 'mb5']);
  }

  classNames = classNames.concat(['body', 'line-height-3']);
  if (currentUser.rollup) {
    classNames = ['mt0', 'rollup', 'h2', 'mb7'];
  }

  const ref = useRef();
  useEffect(() => {
    let contents = null;
    try {
      contents = JSON.parse(value);
    } catch {
      contents = { ops: [{ insert: value }] };
    }
    ref.current.getEditor().setContents(contents);
  });
  const modules = { toolbar: false };
  return (
    <h3 className={classNames.join(' ')}>
      <ReactQuill
        classNames={currentUser.rollup ? 'rollup' : null}
        modules={modules}
        readOnly
        ref={ref}
      />
    </h3>
  );
});

Text.defaultProps = {
  inline: false,
  instructions: false,
};

Text.propTypes = {
  value: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  instructions: PropTypes.bool,
};

export default Text;
